import React, { Fragment } from 'react';


	const newText = (giftCardDetails:any) => {

		if (giftCardDetails.subscriptionLevel === 'Basic') {

			return (
				<section style={{fontSize:'1.2rem' ,marginBottom:'1.3rem'}}>
					<h1  style={{fontSize:'1.2rem' ,marginBottom:'1.3rem'}} >
						You and your little one are lucky ducks because a very thoughtful person in your life bought you a
						one-year Basic membership. This app was developed with you and your baby in mind. 80% of the brain
						is developed in the first 3 years of life. Research shows that children, who have access to
						enriched environments, have 25% more brain development. You can help shape that development
						through play. Fledglings’ Flight includes up to 200 daily exercises from which you can choose
						focused on Gross Motor Skills, Fine Motor Skills, Cognitive Development, Sensory Integration, as
						well as Social-emotional and Language Development. You can read up on the latest research on Child
						Development, Giftedness, Developmental challenges and Self-care for parents by searching our
						library of over 1200 articles.
						{' '}
					</h1>
					<h1  style={{fontSize:'1.2rem' ,marginBottom:'1.3rem'}}>
						Your Basic membership gives you access to all of these resources in addition to milestone tracking
						so you can keep track as your baby achieves 812 milestones between birth and 4 years of age. The
						information you add will help create your child’s developmental profile so we can see if your
						little one is developmentally delayed, on-track, advanced and asynchronous.
					</h1>
				</section>
			);
		} else if (giftCardDetails.validityPeriod === '3') {
				return (
					<section  style={{fontSize:'1.2rem' ,marginBottom:'1.3rem'}}>
						<h1  style={{fontSize:'1.2rem' ,marginBottom:'1.3rem'}}>
							You and your little one are lucky ducks because a very thoughtful person in your life bought you
							a Premium membership for 3 months! This app was developed with you and your baby in mind. 80% of
							the brain is developed in the first 3 years of life. Research shows that children, who have
							access to enriched environments, have 25% more brain development. You can help shape that
							development through play. Fledglings’ Flight includes up to 200 daily exercises from which you
							can choose focused on Gross Motor Skills, Fine Motor Skills, Cognitive Development, Sensory
							Integration, as well as Social-emotional and Language Development. You can read up on the latest
							research on Child Development, Giftedness, Developmental challenges and Self-care for parents by
							searching our library of over 1200 articles.
							{' '}
						</h1>
						<h1  style={{fontSize:'1.2rem' ,marginBottom:'1.3rem'}}>
							Your Premium membership gives you access to all of these resources in addition to milestone
							tracking so you can keep track as your baby achieves 812 milestones between birth and 4 years of
							age. The information you add will help create your child’s developmental profile so we can see
							if your little one is developmentally delayed, on-track, advanced and asynchronous. For three
							months, you will receive a “Toolbox” each month with all of the supplies that you will need to
							complete the exercises, as well as skills-based toys tailored your child’s unique developmental
							needs that month. When you receive your Toolbox, click on “Activities” to reveal the exercise
							related to the main educational toy that you have received. In addition, you will receive an
							email that will explain which items to use with which exercises, as well as bonus exercises with
							other items in the box. Start working with the exercises right away. After 3 weeks, fill out the
							questionnaire to tell us about your child’s experience with the toys. We will use this
							information along with the milestones and the exercises completed to select new skills-based
							toys for the next month. After your third Toolbox, you can choose to continue with your Premium
							membership by clicking on Profile and then clicking on “Become a Member
						</h1>
					</section>
				);
			} else if (giftCardDetails.validityPeriod === "6") {
				return (
					<section  style={{fontSize:'1.2rem' ,marginBottom:'1.3rem'}}>
						<h1  style={{fontSize:'1.2rem' ,marginBottom:'1.3rem'}}> 
							{' '}
							You and your little one are lucky ducks because a very thoughtful person in your life bought you
							a Premium membership for 6 months! This app was developed with you and your baby in mind. 80% of
							the brain is developed in the first 3 years of life. Research shows that children, who have
							access to enriched environments, have 25% more brain development. You can help shape that
							development through play. Fledglings’ Flight includes up to 200 daily exercises from which you
							can choose focused on Gross Motor Skills, Fine Motor Skills, Cognitive Development, Sensory
							Integration, as well as Social-emotional and Language Development. You can read up on the latest
							research on Child Development, Giftedness, Developmental challenges and Self-care for parents by
							searching our library of over 1200 articles.
							{' '}
						</h1>
						<h1  style={{fontSize:'1.2rem' ,marginBottom:'1.3rem'}}>
							Your Premium membership gives you access to all of these resources in addition to milestone
							tracking so you can keep track as your baby achieves 812 milestones between birth and 4 years of
							age. The information you add will help create your child’s developmental profile so we can see
							if your little one is developmentally delayed, on-track, advanced and asynchronous. For six
							months, you will receive a “Toolbox” each month with all of the supplies that you will need to
							complete the exercises, as well as skills-based toys tailored your child’s unique developmental
							needs that month. When you receive your Toolbox, click on “Activities” to reveal the exercise
							related to the main educational toy that you have received. In addition, you will receive an
							email that will explain which items to use with which exercises, as well as bonus exercises with
							other items in the box. Start working with the exercises right away. After 3 weeks, fill out the
							questionnaire to tell us about your child’s experience with the toys. We will use this
							information along with the milestones and the exercises completed to select new skills-based
							toys for the next month. After your sixth Toolbox, you can choose to continue with your Premium
							membership by clicking on Profile and then clicking on “Become a Member”
						</h1>
					</section>
				);
			} else if(giftCardDetails.subscriptionLevel === 'Premium 12 months' && giftCardDetails.validityPeriod === "12") {
				return (
					<section  style={{fontSize:'1.2rem' ,marginBottom:'1.3rem'}}>
						<h1  style={{fontSize:'1.2rem' ,marginBottom:'1.3rem'}}>
							You and your little one are lucky ducks because a very thoughtful and wildly generous person in
							your life bought you a Premium membership for 12 months! This app was developed with you and
							your baby in mind. 80% of the brain is developed in the first 3 years of life. Research shows
							that children, who have access to enriched environments, have 25% more brain development. You
							can help shape that development through play. Fledglings’ Flight includes up to 200 daily
							exercises from which you can choose focused on Gross Motor Skills, Fine Motor Skills, Cognitive
							Development, Sensory Integration, as well as Social-emotional and Language Development. You can
							read up on the latest research on Child Development, Giftedness, Developmental challenges and
							Self-care for parents by searching our library of over 1200 articles.
						</h1>
						<h1  style={{fontSize:'1.2rem' ,marginBottom:'1.3rem'}}>
							Your Premium membership gives you access to all of these resources in addition to milestone
							tracking so you can keep track as your baby achieves 812 milestones between birth and 4 years of
							age. The information you add will help create your child’s developmental profile so we can see
							if your little one is developmentally delayed, on-track, advanced and asynchronous. For a year,
							you will receive a “Toolbox” each month with all of the supplies that you will need to complete
							the exercises, as well as skills-based toys tailored your child’s unique developmental needs
							that month. When you receive your Toolbox, click on “Activities” to reveal the exercise related
							to the main educational toy that you have received. In addition, you will receive an email that
							will explain which items to use with which exercises, as well as bonus exercises with other
							items in the box. Start working with the exercises right away. After 3 weeks, fill out the
							questionnaire to tell us about your child’s experience with the toys. We will use this
							information along with the milestones and the exercises completed to select new skills-based
							toys for the next month. After your twelfth Toolbox, you can choose to continue with your
							Premium membership by clicking on Profile and then clicking on “Become a Member”.
						</h1>
					</section>
				);
			}
		}
	
export default newText;
	// return <Fragment>{newText(giftCardDetails)}</Fragment>;
// };

// export default GiftCardText;
